import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import InviteWidget from './InviteWidget';
import { useAuth } from './auth/AuthProvider';
import { api } from './api/http';

export default function InvitesPage() {
  const navigate = useNavigate();
  const { session } = useAuth();

  const role = String(session?.role || '').toLowerCase();
  const userId = session?.userId ?? null;

  const backHref =
    role === 'technician' ? '/technician-dashboard' :
    role === 'operator' ? '/operator' :
    role === 'customer' ? '/fleet_dashboard' : '/';

  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);
  const [err, setErr] = useState('');

  useEffect(() => {
    let cancelled = false;

    (async () => {
      setLoading(true);
      setErr('');
      try {
        if (!userId) {
          setRows([]);
          return;
        }
        const { data } = await api.get(`/api/users/${userId}/invites`);
        if (cancelled) return;
        setRows(Array.isArray(data) ? data : []);
      } catch {
        if (cancelled) return;
        setErr('Failed to load invites.');
        setRows([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => { cancelled = true; };
  }, [userId]);

  const hasAnyInvites = useMemo(() => rows.length > 0, [rows]);

  const goLogin = () => navigate('/', { replace: true });

  return (
    <div style={{ maxWidth: 800, margin: '40px auto', padding: 16 }}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 12 }}>
        <h2 style={{ margin: 0 }}>My Invites</h2>
        <button
          onClick={() => navigate(backHref)}
          style={{
            marginLeft: 'auto',
            padding: '8px 12px',
            background: '#6c757d',
            color: '#fff',
            border: 'none',
            borderRadius: 6,
            cursor: 'pointer',
          }}
        >
          ← Back
        </button>
      </div>

      {err ? (
        <div style={{ marginBottom: 12, color: 'crimson' }}>{err}</div>
      ) : null}

      {loading ? (
        <div style={{ padding: 12 }}>Loading…</div>
      ) : null}

      {!loading && !err && !hasAnyInvites ? (
        <div
          style={{
            border: '1px solid #e5e7eb',
            borderRadius: 12,
            padding: 16,
            background: '#fff',
          }}
        >
          <div style={{ fontWeight: 700, marginBottom: 6 }}>No invites yet</div>

          {(role === 'technician' || role === 'operator') ? (
            <div style={{ color: '#6b7280', fontSize: 13, marginBottom: 12 }}>
              Ask your customer admin to invite you. When they do, you’ll see the invite here and can accept it.
            </div>
          ) : (
            <div style={{ color: '#6b7280', fontSize: 13, marginBottom: 12 }}>
              No pending invites for this account.
            </div>
          )}

          <button
            onClick={goLogin}
            style={{
              padding: '8px 12px',
              background: '#005792',
              color: '#fff',
              border: 'none',
              borderRadius: 999,
              cursor: 'pointer',
            }}
          >
            Back to login
          </button>
        </div>
      ) : null}

      <InviteWidget title="Pending & Recent Invites" />
    </div>
  );
}
